import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <a href="https://github.com/rufusbiggs/Jammming/tree/main">
            <h3 data-testid="footerText">Check out my code on Github!</h3>
        </a>
    )
}

export default Footer;